import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { ISearchResultItem } from "@/interfaces/search/ISearchResultItem";

export const useUtil = () => {
  const debounce = <Params extends any[]>(func: (...args: Params) => any, timeout: number): (...args: Params) => void => {
    let timer: NodeJS.Timeout;

    return (...args: Params) => {
      clearTimeout(timer)

      timer = setTimeout(() => {
        func(...args)
      }, timeout)
    }
  }

  // Function that returns a promise to read the file
  const toBase64 = (file : File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result as string);
        fileReader.readAsDataURL(file);
    });
  }

  const formatNumber = (value: number): string => {
    return value.toLocaleString('sv-SE');
  }

  const arraysContainTheSameValues = (a: string[], b: string[]): boolean => {
    const sa = new Set(a), sb = new Set(b);
    if (sa.size !== sb.size) {
      return false;
    }
    return a.every(v => sb.has(v));
  };

  const exportToExcel = (data: ISearchResultItem[]) => {
    const fileName = "vrak";
    // Create a new workbook and convert data to worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    
    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    
    // Write workbook and generate buffer
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    
    // Create a Blob object and save the blob as a file
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    saveAs(blob, `${fileName}.xlsx`);
  }

  const stringSort = (a: unknown, b: unknown, ascending = true, locale = 'sv'): number => {
    const sa = String(a ?? '').toLowerCase();
    const sb = String(b ?? '').toLowerCase();
    const cmp = sa.localeCompare(sb, locale);
    return ascending ? cmp : -cmp;
  }

  return {
    debounce,
    toBase64,
    formatNumber,
    arraysContainTheSameValues,
    exportToExcel,
    stringSort
  }
}